import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { FileDown, Loader2 } from "lucide-react";
import { FeedbackForm } from "@/components/program/FeedbackForm";
import { API } from "@/lib/api";

export default function PesertaPage() {
  const { kod } = useParams();
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { axios.get(`${API}/peserta/${kod}`).then((r) => setD(r.data)).catch((e) => setErr(e.response?.data?.detail || "Pautan tidak sah.")); }, [kod]);
  if (err) return <div className="max-w-2xl mx-auto px-4 py-20 text-center text-mute" data-testid="peserta-error">{err}</div>;
  if (!d) return <div className="py-20 grid place-items-center"><Loader2 className="animate-spin text-q" /></div>;
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-8 py-10 sm:py-14 space-y-8" data-testid="peserta-page">
      <header>
        <div className="eyebrow">Bahan peserta · HTE</div>
        <h1 className="font-display text-3xl sm:text-5xl text-ink mt-3" data-testid="peserta-title">{d.tajuk}</h1>
        <a href={`${API}/peserta/${kod}/pdf`} className="mt-4 h-10 px-5 rounded-full border border-line text-sm inline-flex items-center gap-2 hover:bg-surface" data-testid="peserta-pdf-button"><FileDown size={14} /> Muat turun PDF</a>
      </header>
      <section className="rounded-2xl border border-line p-5 sm:p-6 space-y-3" data-testid="peserta-ayat">
        <div className="font-display text-lg text-ink">{d.rujukan}</div>
        <p className="arabic-sm text-xl text-ink text-right leading-loose" lang="ar" dir="rtl">{d.arab}</p>
        <p className="text-sm text-ink/90 leading-relaxed">{d.terjemahan}</p>
        <p className="text-[11px] text-mute font-mono-data">Terjemahan: Abdullah Muhammad Basmeih</p>
      </section>
      <section className="surface rounded-2xl p-5 sm:p-6" data-testid="peserta-refleksi">
        <div className="eyebrow mb-3">Soalan Refleksi</div>
        <ol className="list-decimal pl-5 space-y-2 text-base text-ink">{d.soalan_refleksi.map((q, i) => <li key={i}>{q}</li>)}</ol>
      </section>
      <section className="surface rounded-2xl p-5 sm:p-6" data-testid="peserta-tindakan">
        <div className="eyebrow mb-3">Tindakan Peserta · selepas program, saya akan:</div>
        <ol className="list-decimal pl-5 space-y-2 text-base text-ink">{d.tindakan_selepas.map((q, i) => <li key={i}>{q}</li>)}</ol>
      </section>
      <FeedbackForm kod={kod} />
    </div>
  );
}
